import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * PageTracker — mounted once inside BrowserRouter.
 * Fires a GA4 page_view every time React Router changes routes.
 * Includes a small delay so the React 19 <title> hoisting completes first.
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const t = setTimeout(() => trackPageView(path), 120);
    return () => clearTimeout(t);
  }, [location]);

  return null;
};

export default PageTracker;
